export type ImageSource = 'camera' | 'album';

/**
 * Opens the rear camera or the photo library and hands over the chosen image.
 * why: without `capture` the OS shows its own photo picker (Android) or library (iOS), which
 * also handles the permission prompt. A cancelled picker fires no change event, so `onPick`
 * simply never runs and the caller's state stays as it was.
 */
export function pickImageFile(source: ImageSource, onPick: (file: File) => void): void {
  // Built ad hoc so callers do not carry a hidden input into the DOM.
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = 'image/*';
  // The attribute, not the `capture` property: desktop Chromium has no such property, and the
  // attribute is what mobile browsers read either way.
  if (source === 'camera') input.setAttribute('capture', 'environment');
  input.onchange = () => {
    const file = input.files?.[0];
    if (file) onPick(file);
  };
  input.click();
}
